export enum ErrorCodes {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  HR_DEPARTMENT_HAS_EMPLOYEES_CONNECTED = 'HR_DEPARTMENT_HAS_EMPLOYEES_CONNECTED',
  HR_USER_EXISTS_BY_PHONE = 'HR_USER_EXISTS_BY_PHONE',
  HR_DEPARTMENT_EMPLOYEE_ALREADY_EXISTS = 'HR_DEPARTMENT_EMPLOYEE_ALREADY_EXISTS',
}

export interface ErrorDto {
  errorCode: string;
  message: string;
  statusCode: number;
}
